/** Соответствует полю `order` в api/data/languages.json (ru первый — язык по умолчанию). */
export function sortLanguagesByDisplayOrder(languages) {
  if (!Array.isArray(languages)) return [];
  return [...languages].sort((a, b) => {
    const aOrder = Number.isFinite(a?.order) ? a.order : Number.MAX_SAFE_INTEGER;
    const bOrder = Number.isFinite(b?.order) ? b.order : Number.MAX_SAFE_INTEGER;
    if (aOrder !== bOrder) return aOrder - bOrder;
    return String(a?.name || '').localeCompare(String(b?.name || ''));
  });
}
